
import { Component, Vue, Prop } from "vue-property-decorator";
import { objAny } from "@/common/common-interface";
import maxIntCompute from "@/common/maxIntCompute";
import {
  getModelListAdd,
  pilesAddBatch,
  getExpandPropertyList
} from "@/api/api-basic";
import { getOptionList } from "@/api/api-dict";
import { getProtocolList } from "@/api/api-interconnection";
import regular from "@/common/regular";
import i18n from "@/config/i18n";
@Component
export default class PiModelAdd extends Vue {
  @Prop({
    default: () => {
      return [];
    },
    type: Array
  })
  private devTypeList!: object[];
  private modalShow = false;
  private loading = false;

  private deviceParams: object[] = [
    {
      deviceModelPkId: "",
      deviceType: "",
      quantity: "",
      remark: "",
      snEndNo: "",
      snStartNo: ""
    }
  ];
  private FormData: objAny = {};
  private modalTitle = i18n.t("equipmentList.add");

  private ruleInline: objAny = {
    protocolPkId: [
      {
        required: true,
        message: i18n.t("equipmentList.protocolPkIdPl"),
        trigger: "change"
      }
    ],
    deviceType: [
      {
        required: true,
        message: i18n.t("equipmentModel.deviceTypePl"),
        trigger: "change"
      }
    ],
    deviceModelPkId: [
      {
        required: true,
        message: i18n.t("equipmentModel.deviceModelPkIdPl"),
        trigger: "change"
      }
    ],
    quantity: [
      {
        trigger: "change",
        validator: regular.int,
        required: true
      }
    ],
    snStartNo: [
      {
        required: true,
        trigger: "blur",
        validator: (rule: objAny, value: string) => {
          // const reg = /^\d{8}$|^\d{12}$/;
          const reg = /^\d+$/;
          if (!value) {
            return new Error(i18n.t("equipmentList.snNull") + "");
          } else if (!reg.test(value)) {
            return new Error(i18n.t("equipmentList.snInt") + "");
          }
          return true;
        }
      }
    ],
    snEndNo: [
      {
        required: true,
        trigger: "blur",
        validator: (rule: objAny, value: string) => {
          // const reg = /^\d{8}$|^\d{12}$/;
          const reg = /^\d+$/;
          if (!value) {
            return new Error(i18n.t("equipmentList.snNull") + "");
          } else if (!reg.test(value)) {
            return new Error(i18n.t("equipmentList.snInt") + "");
          }
          return true;
        }
      }
    ]
  };
  private formItem: objAny = {
    deviceParams: [],
    protocolPkId: ""
  };
  private extParamList: object[] = [];
  private protocolList: object[] = [];

  private paramList: objAny = {
    deviceModelPkId: "",
    deviceType: "",
    quantity: "",
    remark: "",
    snEndNo: "",
    snStartNo: ""
  };
  private protocolShow = false;

  private modelList: object[] = [];
  private modelListObj: objAny = {
    2: [],
    3: []
  };
  private oprList = [];
  private deviceTypeList = [];
  private matchEquipmentList = [];
  private stationList = [];
  private numberQuantity = 0;

  public open() {
    if (!this.FormData.$el) {
      this.$nextTick((): void => {
        this.FormData = this.$refs["formItem"];
      });
    } else {
      this.handleReset();
    }
    this.modalShow = true;
    this.formItem.deviceParams = [];
    this.addFormData();

    this.getProtocolList();
    this.formItem.protocolPkId = "";
  }

  public addFormData() {
    // if (this.formItem.deviceParams.length > 0) {
    //   json = this.formItem.deviceParams[this.formItem.deviceParams.length - 1];
    // } else {
    const json = JSON.parse(JSON.stringify(this.paramList));
    // }
    // json = JSON.parse(JSON.stringify(json));
    if (this.formItem.deviceParams.length > 0) {
      const obj = this.formItem.deviceParams[
        this.formItem.deviceParams.length - 1
      ];

      json.deviceModelPkId = obj.deviceModelPkId;
      json.deviceType = obj.deviceType;
    }
    this.formItem.deviceParams.push(json);
  }

  public loseFocus(unit: objAny) {
    //  && unit.snEndNo >= unit.snStartNo
    if (unit.snEndNo && unit.snStartNo) {
      this.numberQuantity = parseFloat(
        maxIntCompute(unit.snEndNo, unit.snStartNo)
      );
      // this.numberQuantity = parseInt(unit.snEndNo) - parseInt(unit.snStartNo);
      unit.quantity = this.numberQuantity + 1;
    } else {
      unit.quantity = "";
    }
    // this.$set(this.formItem.deviceParams, index, unit);
  }

  delFormData(index: number) {
    this.formItem.deviceParams.splice(index, 1);
  }

  public handleSubmit(): void {
    this.FormData.validate((valid: boolean) => {
      if (valid) {
        this.submitData();
      }
    });
  }
  public closeModal(): void {
    this.modalShow = false;
  }
  public handleReset() {
    this.FormData.resetFields();
  }
  async getModelList(param: string): Promise<void> {
    if (param) {
      const ret = await getModelListAdd({ deviceType: param });
      if (ret.status === this.$config.apiStatus) {
        this.$set(this.modelListObj, param, ret.data);
      }
    }
  }

  async submitData(): Promise<void> {
    const extParamList: object[] = [];
    if (this.extParamList.length > 0) {
      this.extParamList.map((item: objAny) => {
        extParamList.push({
          propertyPkId: item.propertyPkId,
          propertyValue: item.propertyValue
        });
      });
    }
    const json = JSON.parse(JSON.stringify(this.formItem));
    json.deviceParams.map((item: objAny) => {
      item.quantity = parseInt(item.quantity);
      item.extParamList = extParamList;
      item.protocolPkId = this.formItem.protocolPkId;
    });
    this.loading = true;
    const ret = await pilesAddBatch(json);
    if (ret.status === this.$config.apiStatus) {
      this.$Message.success(i18n.t("operationSucess") + "");
      this.$emit("success");
      this.modalShow = false;
    }
    this.loading = false;
  }
  public protocolChange(val: string) {
    this.getExpandPropertyList(val);
    this.protocolShow = true;
  }
  async getProtocolList(): Promise<void> {
    const ret = await getProtocolList({
      protocolType: 0
    });
    if (ret.status === this.$config.apiStatus) {
      this.protocolList = ret.data;
    }
  }
  async getExpandPropertyList(protocolPkId: string) {
    const ret = await getExpandPropertyList({
      protocolPkId: protocolPkId
    });
    if (ret.status === this.$config.apiStatus) {
      const data: object[] = ret.data || [];

      if (data.length > 0) {
        const extParamList: object[] = [];
        const propertyDictPkIdList: string[] = [];
        data.map((item: objAny) => {
          propertyDictPkIdList.push(item.propertyDictPkId);
          const json: objAny = {
            propertyPkId: item.propertyPkId,
            propertyDictPkId: item.propertyDictPkId,
            propertyName: item.propertyName,
            propertyValue: ""
          };

          extParamList.push(json);
        });

        getOptionList(propertyDictPkIdList).then(dataObj => {
          for (const i in dataObj) {
            extParamList.map((item: objAny) => {
              if (item.propertyDictPkId == i) {
                item.optionList = dataObj[i];
                if (dataObj[i][0] && item.propertyValue == "") {
                  item.propertyValue = dataObj[i][0].itemKey;
                }
              }
            });
          }
          this.extParamList = extParamList;
        });
      } else {
        this.protocolShow = false;
        this.extParamList = [];
      }
    }
  }
  mounted() {
    this.$emit("getChild", this);
  }
}
